module.exports = __webpack_public_path__ + "img/group_introduct_img.7106eb0d.png";